import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Collapse, Table, TableBody, TableCell, TableRow, IconButton, Button, Typography, Paper, LinearProgress } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import clsx from "clsx";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import debounce from "lodash/debounce";
import api from "../../store/api";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { CrossHairIcon } from "../../assets/iconComponents/Icons";
import { RootState } from "../../store/rootReducer";
import { useHistory } from "react-router";
import { showBookingToast } from "../../store/modules/appStateSlice";

import { getOriginLocationString, getDestinationLocationString, getTimeFromDate } from "../../common/helpers";
import { ISchedule } from "../../common/types";
import eventNames from "../../store/signalr/eventNames";
import { addTaskForEvent, removeTaskForEvent } from "../../store/signalr/tasksForEvents";
import useWindowSize from "../shared/useWindowSize";
import RequestedTableHead from "./scheduleTable/RequestedTableHead";
import InProgressTableHead from "./scheduleTable/InProgressTableHead";
import CompletedTableHead from "./scheduleTable/CompletedTableHead";
import TransferRequestItem from "./TransferRequestItem";
import { NeedIcon, NeedListItem, AcuityNeedItem, PriorityBadge } from "./TransferIcons";
import Separator from "./helpers/Separator";
import JoinedScheduledTable from "./helpers/JoinedScheduledTable";
import ResumeTripPanel from "./ResumeTripPanel/ResumeTripPanel";
import { applyGlobalChanges } from "../../store/modules/plannerSlice";
import {
  getBearingAngle,
  getData,
  getRequestedStatusString,
  getTransferStatusString,
  hubMessageHandler,
  setData,
} from "./helpers/transferScheduleHelpers";
import StartTripFooter from "./helpers/StartTripFooter";
import TransferScheduleAdHocTable from "./TransferScheduleAdHocTable";

interface TransferScheduleWidgetProps {
  selectedDay: string;
  selectedLocations: string[];

  setCurrentBookingId: any;
  setCurrentTransferId: any;
  setCurrentTransferData: any;
  setShowVehicleModal: any;
  setShowScheduleModal: any;
  setShowScheduleModalAssignVehicleOption: any;
  roles: any;
  setParentLoading : any;
  setCurrentTripPlannerId: any;
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
    padding: "16px 0px 16px 0px",
  },
  table: {
    width: "100%",

    tableLayout: "fixed",
    backgroundColor: "#00152E",
  },
  muiTableBody: {
    backgroundColor: "#fff",
  },
  tableHead: {
    backgroundColor: "#00152E",
    "& > *": {
      fontSize: 18,
      fontWeight: 400,
      opacity: 0.3,
    },
  },
  tableBody: {
    backgroundColor: "#002047",
    cursor: "pointer",
    "& > *": {
      fontSize: 18,
      fontWeight: 500,
    },
    height: 33,
  },
  tableCell: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    height: 33,
    paddingLeft: 0,
  },
  tableCellPad: {
    padding: "6px 0 6px 0 !important",

    "&>span": {
      paddingLeft: 20,
    }
  },
  transerSwitch: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 150,
    height: 32,
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
  loading: {
    width: "100%",
    position: "fixed",
    top: "113px",

    "& > * + *": {
      marginTop: theme.spacing(2, 0, 0, 50),
    },
  },
  priorityColumn: {
    paddingLeft: 0,
  },
  needIconCenter: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    minHeight: 33,
    border: 0,
    paddingLeft: 0,
  },
  animatedUpdatedItem: {
    animation: `$updatedTransferEffect 60000ms ${theme.transitions.easing.easeInOut}`,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08) !important",
    },
  },
  "@keyframes updatedTransferEffect": {
    "0%": { backgroundColor: "#F4B8273A" },
    "100%": { backgroundColor: "#002047" },
  },
  rowTitle: {
    fontSize: 21,
    fontWeight: 400,
    marginLeft: 15,
  },
  removeHover: {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));

const CreateLoadingLine = (props: any): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.loading} style={props.show ? { display: "" } : { visibility: "hidden" }}>
      <LinearProgress color="primary" />
    </div>
  );
};

const alertOne = require("../../assets/sounds/alertOne.mp3");
const alertTwo = require("../../assets/sounds/alertTwo.mp3");

const componentTaskId = "transferScheduleWidget";

function TransferScheduleWidget(props: TransferScheduleWidgetProps) {
  const {
    selectedDay,
    selectedLocations,
    setCurrentBookingId,
    setCurrentTransferId,
    setCurrentTransferData,
    setShowVehicleModal,
    setShowScheduleModal,
    setShowScheduleModalAssignVehicleOption,
    roles,
    setParentLoading,
    setCurrentTripPlannerId,
  } = props;
  const classes = useStyles();
  const [collapse, setCollapse] = React.useState([true, true, true, true]);
  const [checks, setChecks] = React.useState<any[]>([false]);
  const [transferMode, setTransferMode] = React.useState(getData("transferMode") || 0);
  const [wardMode, setWardMode] = React.useState(roles.wardSwitch ? 0 : 1);
  const { authStore } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = React.useState(false);
  const [scheduleList, setScheduleList] = React.useState<ISchedule[]>([]);
  const [scheduleRequestedList, setScheduleRequestedList] = React.useState<ISchedule[]>([]);
  const [scheduleScheduledForTransportList, setScheduleScheduledForTransportList] = React.useState<ISchedule[]>([]);
  const [scheduleInProgressList, setScheduleInProgressList] = React.useState<ISchedule[]>([]);
  const [scheduleCompleteList, setScheduleCompleteList] = React.useState<ISchedule[]>([]);
  const [scheduleAdHocList, setScheduleAdHocList] = React.useState<ISchedule[]>([]);
  const selectedLocationsRef = React.useRef(selectedLocations);
  const selectedDayRef = React.useRef(selectedDay);
  const [updatedTransfers, setUpdatedTransfers] = React.useState<any[]>([]);
  const updatedTrasfersRef = React.useRef(updatedTransfers);
  const [activeTripId, setActiveTripId] = React.useState("");
  const[vechiclecount,setvechiclecount] =React.useState(0);
  /* const [bookingId, setBookingId] = React.useState(props.location.state);*/
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const { windowWidth } = useWindowSize();

  const audioRequest = new Audio(alertOne);
  const audioSchedule = new Audio(alertTwo);

  const transferRequestAlert = () => {
    audioRequest.play();
  };
  const transferScheduleAlert = () => {
    audioSchedule.play();
  };

  const isFullTableWidth = windowWidth > 1280;

  const handleClose = () => {
    setMessage("");
    clearSelections();
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const whenNewTransferDo = (newTransferDetails: any) => {
    if (
      (!selectedLocationsRef.current ||
        selectedLocationsRef.current.length == 0 ||
        !newTransferDetails.NewLocationId ||
        (selectedLocationsRef.current as string[]).filter((s) => s === newTransferDetails.NewLocationId).length > 0) &&
      (!newTransferDetails.NewDate || newTransferDetails.NewDate === selectedDayRef.current)
    ) {
      hubMessageHandler(
        true,
        selectedLocationsRef.current,
        selectedDayRef.current,
        newTransferDetails.TransferId,
        updatedTrasfersRef,
        setUpdatedTransfers,
        authStore.data?.CustomerId||null,
        deBounceGettScheduleList
      );
      if (collapse[0]) transferRequestAlert();
    }
  };

  const whenTransferUpdatedDo = (newTransferDetails: any) => {
    if (
      (!selectedLocationsRef.current ||
        selectedLocationsRef.current.length == 0 ||
        !newTransferDetails.PreviousLocationId ||
        (selectedLocationsRef.current as string[]).filter((s) => s === newTransferDetails.PreviousLocationId).length > 0 ||
        !newTransferDetails.NewLocationId ||
        (selectedLocationsRef.current as string[]).filter((s) => s === newTransferDetails.NewLocationId).length > 0) &&
      (!newTransferDetails.PreviousDate ||
        newTransferDetails.PreviousDate === selectedDayRef.current ||
        !newTransferDetails.NewDate ||
        newTransferDetails.NewDate === selectedDayRef.current)
    ) {
      hubMessageHandler(
        false,
        selectedLocationsRef.current,
        selectedDayRef.current,
        message,
        updatedTrasfersRef,
        setUpdatedTransfers,
        authStore.data?.CustomerId||null,
        deBounceGettScheduleList
      );
    }
  };

  const whenTransferScheduleUpdatedDo = (newTransferDetails: any) => {
    if (
      (!selectedLocationsRef.current ||
        selectedLocationsRef.current.length == 0 ||
        !newTransferDetails.PreviousLocationId ||
        (selectedLocationsRef.current as string[]).filter((s) => s === newTransferDetails.PreviousLocationId).length > 0 ||
        !newTransferDetails.NewLocationId ||
        (selectedLocationsRef.current as string[]).filter((s) => s === newTransferDetails.NewLocationId).length > 0) &&
      (!newTransferDetails.PreviousDate ||
        newTransferDetails.PreviousDate === selectedDayRef.current ||
        !newTransferDetails.NewDate ||
        newTransferDetails.NewDate === selectedDayRef.current)
    ) {
      hubMessageHandler(
        true,
        selectedLocationsRef.current,
        selectedDayRef.current,
        message,
        updatedTrasfersRef,
        setUpdatedTransfers,
        authStore.data?.CustomerId||null,
        deBounceGettScheduleList
      );
      if (collapse[1]) transferScheduleAlert();
    }
  };
  const getVehicles = async (customer: any) => {
    let _loc=customer;
    const res = await api.getVechicles('customerId=' + _loc);
    if (res.hasError === false) {
        setvechiclecount(res._result.length);
    }
    }  
  React.useEffect(() => {
    addTaskForEvent(eventNames.newTransfer, componentTaskId, whenNewTransferDo);
    addTaskForEvent(eventNames.transferUpdated, componentTaskId, whenTransferUpdatedDo);
    addTaskForEvent(eventNames.transferScheduleUpdated, componentTaskId, whenTransferScheduleUpdatedDo);

    return () => {
      removeTaskForEvent(eventNames.newTransfer, componentTaskId);
      removeTaskForEvent(eventNames.transferUpdated, componentTaskId);
      removeTaskForEvent(eventNames.transferScheduleUpdated, componentTaskId);
    };
  }, [whenNewTransferDo, whenTransferUpdatedDo, whenTransferScheduleUpdatedDo]);

  React.useEffect(() => {
    selectedLocationsRef.current = selectedLocations;
    selectedDayRef.current = selectedDay;
  });

  const getScheduleList = async (showAll: boolean, filter: any): Promise<void> => {
    setLoading(true);
    setParentLoading(true);
    filter.isPlannerRequest = false;
    const _res = await api.getScheduleList("version="+Math.random().toString()+Math.random().toString()+Math.random().toString(), filter);
    console.log(_res);
    if (_res !== null && _res.data !== null && _res.data.model !== null && !_res.data.hasError) {
      if (_res.data !== null && _res.data.model !== null) {
        // if there is an active trip => show bottom panel
        if (
          (_res?.data?.model?.hasActiveTripForSession === true && _res?.data?.model?.activeTrip?.tripId) ||
          (_res?.data?.model?.hasActiveTripForVehicle === false && _res?.data?.model?.activeTrip?.tripId)
        ) {
          setActiveTripId(_res?.data?.model?.activeTrip?.tripId);
        }

        let _scheduleList: ISchedule[] = _res.data.model.transferResponseList;
        if (_scheduleList !== null) {
          setScheduleList(_res.data.model);

          let _scheduleRequestedList = _scheduleList.filter((sch) => sch.status === 1);
          let _scheduleScheduledForTransportList = _scheduleList.filter((sch) => sch.status === 2);
          let _scheduleInProgressList = _scheduleList.filter((sch) => [3, 7, 8, 9].some((item) => sch.status === item));
          let _scheduleCompleteList = _scheduleList.filter((sch) => [4, 6, 10, 11].some((item) => sch.status === item) && sch.scheduledDate != null);
          let _scheduleAdHocList = _scheduleList.filter((sch) => sch.status === 13);
          if (roles.isCustomerDriver)
          {
            _scheduleScheduledForTransportList = _scheduleScheduledForTransportList.filter((sch) => sch.fleet === "2");
            _scheduleInProgressList = _scheduleInProgressList.filter((sch) => sch.fleet === "2");
            _scheduleCompleteList = _scheduleCompleteList.filter((sch) => sch.fleet === "2");
            _scheduleAdHocList = _scheduleAdHocList.filter((sch) => sch.fleet === "2");
          }
          if (roles.isSMADriver)
          {
            _scheduleScheduledForTransportList = _scheduleScheduledForTransportList.filter((sch) => sch.fleet != "2");
            _scheduleInProgressList = _scheduleInProgressList.filter((sch) => sch.fleet != "2");
            _scheduleCompleteList = _scheduleCompleteList.filter((sch) => sch.fleet != "2");
            _scheduleAdHocList = _scheduleAdHocList.filter((sch) => sch.fleet != "2");
          }
          setChecks(getData("checks") || new Array(_scheduleScheduledForTransportList.length).fill(false));

          _scheduleRequestedList.sort(function (a, b) {
            if (a.createdOn < b.createdOn) return 1;
            else if (a.createdOn > b.createdOn) return -1;
            return 0;
          });
       
          setScheduleRequestedList(_scheduleRequestedList);

          _scheduleAdHocList.sort(function (a, b) {
            if (a.createdOn < b.createdOn) return 1;
            else if (a.createdOn > b.createdOn) return -1;
            return 0;
          });
          setScheduleAdHocList(_scheduleAdHocList);

          _scheduleScheduledForTransportList.sort(function (a, b) {
            if (a.scheduledDate!! < b.scheduledDate!!) return -1;
            else if (a.scheduledDate!! > b.scheduledDate!!) return 1;
            return 0;
          });

          const preparedScheduleScheduledForTransportList = _scheduleScheduledForTransportList.map((item) => ({
            ...item,
            bearingAngle: getBearingAngle(
              item.originLatitude || item.originCustLocationLatitude,
              item.originLongitude || item.originCustLocationLongitude,
              item.destinationLatitude || item.destCustLocationLatitude,
              item.destinationLongitude || item.destCustLocationLongitude
            ),
          }));
          setScheduleScheduledForTransportList(preparedScheduleScheduledForTransportList);
          dispatch(applyGlobalChanges([]));
          setScheduleInProgressList(_scheduleInProgressList);
          setScheduleCompleteList(_scheduleCompleteList);
        }
      }
    } else {
      setScheduleList([]);
      setScheduleRequestedList([]);
      setScheduleScheduledForTransportList([]);
      setScheduleInProgressList([]);
      setScheduleCompleteList([]);
    }
    setLoading(false);
    setParentLoading(false);
  };
 
  const deBounceGettScheduleList = React.useMemo(
    () =>
      debounce(async (showAll: boolean, filter): Promise<void> => {
        await getScheduleList(showAll, filter);
      }, 2000),
    []
  );

  React.useEffect(() => {
    getScheduleList(false, {
      locations: selectedLocations,
      scheduledDate: selectedDay,
      Customerid:authStore.data?.CustomerId||null,
      version: Math.random().toString()+Math.random().toString()+Math.random().toString(),
    });
    getVehicles(authStore.data?.CustomerId);
  }, [selectedLocations, selectedDay]);

  const updateCollapse = (index: number) => {
    setCollapse((previousValue) => previousValue.map((item, i) => (index == i ? !item : item)));
  };

  const updateChecks = (index: number) => {
    const updatedChecks = checks.map((item, i) => (i == index ? !item : item));
    setChecks(updatedChecks);
    setData("checks", updatedChecks);
  };

  const assignToMeClick = async (bookId: string, transId: string): Promise<void> => {
    if (!(roles.isSMADriver || roles.isCustomerDriver)) return;
    try {
      setLoading(true);
      setParentLoading(true);
      var req = {};
      const res = await api.assignJob("", { transferId: transId });
      if (!res.data.hasError)
        setScheduleScheduledForTransportList((prev) => prev.map((item) => (item.bookingId == bookId ? { ...item, status: 5 } : item)));
      else {
        dispatch(showBookingToast({ open: true, message: res.data.message }));
        setTimeout(() => {
          dispatch(showBookingToast({ open: false, message: "" }));
        }, 4000);
      }
      setLoading(false);
      setParentLoading(false);
    } catch (err) {
      setLoading(false);
      setParentLoading(false);
    }
  };

  const startTripCall = async () => {
    const transferIds = checks
      .map((item, index) => (item ? index : -1))
      .filter((item) => item != -1)
      .map((item) => scheduleScheduledForTransportList[item].transferId);
    api
      .initTrip("", transferIds)
      .then((res) => {
        setData("checks", null);
        history.push(`/transfertrip/${res.model.tripId}`);
      })
      .catch((error) => {
        setMessage(error.response.data.errorMessage);
        handleClickOpen();
      });
  };

  const clearSelections = () => {
    const updatedChecks = checks.map(() => false);
    setChecks(updatedChecks);
    setData("checks", updatedChecks);
  };

  return (
    <>
      <Paper style={{ height: "100%", paddingBottom: 120, borderRadius: 0 }}>
        <div style={{ marginBottom: 80 }}>
          <CreateLoadingLine show={loading} />
        </div>
        <Table className={classes.table}>
          <TableBody>
            <TableRow className={classes.root}>
              <TableCell>
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  aria-label="expand row"
                  size="small"
                  onClick={() => updateCollapse(0)}
                  className={classes.removeHover}
                  disableRipple
                >
                  {collapse[0] ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                  <Typography variant="body1" component="div" className={classes.rowTitle}>
                    Requested
                  </Typography>
                  {!collapse[0] && (
                    <Typography
                      variant="body1"
                      component="div"
                      style={{
                        fontSize: 21,
                        fontWeight: 500,
                        opacity: 0.36,
                        marginLeft: 15,
                      }}
                    >
                      {scheduleRequestedList.length} Transfers
                    </Typography>
                  )}
                </IconButton>
                {roles.wardSwitch && collapse[0] && (
                  <span
                    style={{
                      display: "inline-flex",
                      float: "right",
                      marginRight: 25,
                      border: "1px solid #02489D",
                      borderRadius: 20,
                      overflow: "hidden",
                    }}
                  >
                    <span
                      onClick={() => setWardMode(0)}
                      className={classes.transerSwitch}
                      style={{
                        background: wardMode == 0 ? "#02489D" : "transparent",
                      }}
                    >
                      All Wards
                    </span>
                    <span
                      onClick={() => setWardMode(1)}
                      className={classes.transerSwitch}
                      style={{
                        background: wardMode == 1 ? "#02489D" : "transparent",
                      }}
                    >
                      My Wards
                    </span>
                  </span>
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                style={{
                  paddingBottom: 5,
                  paddingTop: 5,
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
                colSpan={0}
              >
                <Collapse in={collapse[0]} timeout="auto" unmountOnExit>
                  <Box margin={0}>
                    <Table size="small" aria-label="purchases" style={{ tableLayout: "fixed" }}>
                      <RequestedTableHead isFullTableWidth={isFullTableWidth} classes={classes} />
                      <TableBody>
                        {scheduleRequestedList.length > 0 ? (
                          scheduleRequestedList.map((row, index) => {
                            //if (wardMode == 1 && row.originWardId != authStore.data?.ward && row.destinationWardId != authStore.data?.ward)
                              //return null;
                            return (
                              <TransferRequestItem
                                key={row.transferId}
                                transferRequest={row}
                                updatedTransfers={updatedTransfers}
                                isFullTableWidth={isFullTableWidth}
                                getRequestedStatusString={getRequestedStatusString}
                                scheduleRequestedList={scheduleRequestedList}
                                setCurrentTransferId={setCurrentTransferId}
                                setCurrentTransferData={setCurrentTransferData}
                                setCurrentBookingId={setCurrentBookingId}
                                setShowScheduleModal={setShowScheduleModal}
                                showAdHocRequestModal={() => {}}
                              />
                            );
                          })
                        ) : (
                          <TableRow className={classes.tableCell}>
                            <TableCell align="center" colSpan={9}>
                              No Records Found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {!roles.isCustomerDriver && <div style={{ paddingTop: 15, backgroundColor: "#00152E" }}>
          <TransferScheduleAdHocTable
            transfers={scheduleAdHocList}
            updatedTransfers={updatedTransfers}
            setCurrentTransferId={setCurrentTransferId}
            setCurrentTransferData={setCurrentTransferData}
            setCurrentBookingId={setCurrentBookingId}
            setShowScheduleModal={setShowScheduleModal}
            setShowScheduleModalAssignVehicleOption={setShowScheduleModalAssignVehicleOption}
            roles={roles}
          />
        </div>}

        <div style={{ paddingTop: 15, backgroundColor: "#00152E" }}>
          <Table className={classes.table}>
            <TableBody>
              <TableRow className={classes.root}>
                <TableCell>
                  <IconButton
                    style={{ marginLeft: "-10px" }}
                    aria-label="expand row"
                    size="small"
                    onClick={() => updateCollapse(1)}
                    className={classes.removeHover}
                    disableRipple
                  >
                    {collapse[1] ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                    <Typography variant="body1" component="div" className={classes.rowTitle}>
                      Scheduled For Transport
                    </Typography>
                    {!collapse[1] && (
                      <Typography
                        variant="body1"
                        component="div"
                        style={{
                          fontSize: 21,
                          fontWeight: 500,
                          opacity: 0.36,
                          marginLeft: 15,
                        }}
                      >
                        {scheduleScheduledForTransportList.length} Transfers
                      </Typography>
                    )}
                  </IconButton>
                  {roles.transerSwitch && collapse[1] && (
                    <span
                      style={{
                        display: "inline-flex",
                        float: "right",
                        marginRight: 25,
                        border: "1px solid #02489D",
                        borderRadius: 20,
                        overflow: "hidden",
                      }}
                    >
                      <span
                        onClick={() => {
                          setTransferMode(0);
                          setData("transferMode", 0);
                        }}
                        className={classes.transerSwitch}
                        style={{
                          background: transferMode == 0 ? "#02489D" : "transparent",
                        }}
                      >
                        All Transfers
                      </span>
                      <span
                        onClick={() => {
                          setTransferMode(1);
                          setData("transferMode", 1);
                        }}
                        className={classes.transerSwitch}
                        style={{
                          background: transferMode == 1 ? "#02489D" : "transparent",
                        }}
                      >
                        {roles.transerSwitchRightText}
                      </span>
                    </span>
                  )}
                </TableCell>
              </TableRow>
              <JoinedScheduledTable
                collapse={collapse}
                parentClasses={classes}
                roles={roles}
                isFullTableWidth={isFullTableWidth}
                scheduleScheduledForTransportList={scheduleScheduledForTransportList}
                transferMode={transferMode}
                history={history}
                checks={checks}
                updatedTransfers={updatedTransfers}
                updateChecks={updateChecks}
                setCurrentTransferId={setCurrentTransferId}
                setCurrentBookingId={setCurrentBookingId}
                setShowVehicleModal={setShowVehicleModal}
                assignToMeClick={assignToMeClick}
                setCurrentTripPlannerId={setCurrentTripPlannerId}
                vechiclecount={vechiclecount}
              />
            </TableBody>
          </Table>
        </div>
        <div style={{ paddingTop: 15, backgroundColor: "#00152E" }}>
          <Table className={classes.table}>
            <TableBody>
              <TableRow className={classes.root}>
                <TableCell>
                  <IconButton
                    style={{ marginLeft: "-10px" }}
                    aria-label="expand row"
                    size="small"
                    onClick={() => updateCollapse(2)}
                    className={classes.removeHover}
                    disableRipple
                  >
                    {collapse[2] ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                    <Typography variant="body1" component="div" className={classes.rowTitle}>
                      In Progress
                    </Typography>
                    {!collapse[2] && (
                      <Typography
                        variant="body1"
                        component="div"
                        style={{
                          fontSize: 21,
                          fontWeight: 500,
                          opacity: 0.36,
                          marginLeft: 15,
                        }}
                      >
                        {scheduleInProgressList.length} Transfers
                      </Typography>
                    )}
                  </IconButton>
                  {roles.canTrackFleet && !roles.isSMADriver && (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        float: "right",
                        marginRight: 25,
                      }}
                    >
                      <Button onClick={() => history.push("/trackfleet")}>
                        <CrossHairIcon style={{ color: "#F4B827", width: 22 }} />
                        <Typography
                          variant="body1"
                          component="div"
                          style={{
                            fontSize: 21,
                            fontWeight: 500,
                            opacity: 0.9,
                            marginLeft: 15,
                            color: "#F4B827",
                          }}
                        >
                          Track Fleet
                        </Typography>
                      </Button>
                    </span>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    paddingBottom: 5,
                    paddingTop: 5,
                    paddingLeft: 0,
                    paddingRight: 0,
                  }}
                  colSpan={0}
                >
                  <Collapse in={collapse[2]} timeout="auto" unmountOnExit>
                    <Box margin={0}>
                      <Table size="small" aria-label="purchases" className={classes.table}>
                        <InProgressTableHead isFullTableWidth={isFullTableWidth} classes={classes} />
                        <TableBody>
                          {scheduleInProgressList.length > 0 ? (
                            scheduleInProgressList.map((row, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <TableRow
                                    onClick={(e) => history.push(`/transferDetails/${row.bookingId}/${row.transferId}`)}
                                    hover
                                    key={row.bookingId}
                                    className={clsx(classes.tableBody, {
                                      [classes.animatedUpdatedItem]: updatedTransfers.some(
                                        (e) => e.TransferId === row.transferId && new Date().getTime() - e.UpdatedDate < 60000
                                      ),
                                    })}
                                  >
                                    <TableCell className={classes.tableCell}>{getTimeFromDate(row.scheduledDate)}</TableCell>
                                    {isFullTableWidth && (
                                      <TableCell className={classes.tableCell}>
                                        {row.firstName} {row.lastName}
                                      </TableCell>
                                    )}
                                    {isFullTableWidth && (
                                      <TableCell className={classes.needIconCenter}>
                                        {row.bookingSpecialNeeds.map((item) => (
                                          <NeedIcon
                                            key={row.bookingId + item.specialNeedId}
                                            iconName={item.specialNeedIconUrl.split("/")[item.specialNeedIconUrl.split("/").length - 1]}
                                          />
                                        ))}
                                        {row.mobility === 1 ? (
                                          <NeedListItem key="notambulant" text={"Not Ambulant"} iconUrl={"../../assets/svgs/nonambulant.svg"} />
                                        ) : (
                                          <NeedListItem key="ambulant" text={"Ambulant"} iconUrl={"../../assets/svgs/ambulant.svg"} />
                                        )}
                                        {row.classification ? <AcuityNeedItem key="acuity" text={row.classification} /> : null}
                                      </TableCell>
                                    )}
                                    <TableCell className={classes.tableCell}>{getOriginLocationString(row)}</TableCell>
                                    <TableCell className={classes.tableCell}>{getDestinationLocationString(row)}</TableCell>

                                    <TableCell className={classes.priorityColumn}>
                                      <PriorityBadge priority={row.priority} />
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                      {`${row.assignedVehicle} - ${getTransferStatusString(row.status)}`}
                                    </TableCell>
                                    <TableCell style={{ width: 20 }} align="right">
                                      <IconButton aria-label="expand row" size="small">
                                        <ArrowForwardIosIcon style={{ fontSize: 20 }} />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                  <Separator />
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <TableRow>
                              <TableCell align="center" colSpan={8}>
                                No Records Found
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div style={{ paddingTop: 15, backgroundColor: "#00152E" }}>
          <Table className={classes.table}>
            <TableBody>
              <TableRow className={classes.root}>
                <TableCell>
                  <IconButton
                    style={{ marginLeft: "-10px" }}
                    aria-label="expand row"
                    size="small"
                    onClick={() => updateCollapse(3)}
                    className={classes.removeHover}
                    disableRipple
                  >
                    {collapse[3] ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                    <Typography variant="body1" component="div" className={classes.rowTitle}>
                      Completed
                    </Typography>
                    {!collapse[3] && (
                      <Typography
                        variant="body1"
                        component="div"
                        style={{
                          fontSize: 21,
                          fontWeight: 500,
                          opacity: 0.36,
                          marginLeft: 15,
                        }}
                      >
                        {scheduleCompleteList.length} Transfers
                      </Typography>
                    )}
                  </IconButton>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    paddingBottom: 5,
                    paddingTop: 5,
                    paddingLeft: 0,
                    paddingRight: 0,
                  }}
                  colSpan={0}
                >
                  <Collapse in={collapse[3]} timeout="auto" unmountOnExit>
                    <Box margin={0}>
                      <Table size="small" aria-label="purchases" className={classes.table}>
                        <CompletedTableHead isFullTableWidth={isFullTableWidth} classes={classes} />
                        <TableBody>
                          {scheduleCompleteList.length > 0 ? (
                            scheduleCompleteList.map((row, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <TableRow
                                    onClick={(e) => history.push(`/transferDetails/${row.bookingId}/${row.transferId}`)}
                                    hover
                                    key={row.bookingId}
                                    className={clsx(classes.tableBody, {
                                      [classes.animatedUpdatedItem]: updatedTransfers.some(
                                        (e) => e.TransferId === row.transferId && new Date().getTime() - e.UpdatedDate < 60000
                                      ),
                                    })}
                                  >
                                    <TableCell>{getTimeFromDate(row.scheduledDate)}</TableCell>
                                    {isFullTableWidth && (
                                      <TableCell className={classes.tableCell}>
                                        {row.firstName} {row.lastName}
                                      </TableCell>
                                    )}
                                    {isFullTableWidth && (
                                      <TableCell className={classes.needIconCenter}>
                                        {row.bookingSpecialNeeds.map((item) => (
                                          <NeedIcon
                                            key={row.bookingId + item.specialNeedId}
                                            iconName={item.specialNeedIconUrl.split("/")[item.specialNeedIconUrl.split("/").length - 1]}
                                          />
                                        ))}
                                        {row.mobility === 1 ? (
                                          <NeedListItem key="notambulant" text={"Not Ambulant"} iconUrl={"../../assets/svgs/nonambulant.svg"} />
                                        ) : (
                                          <NeedListItem key="ambulant" text={"Ambulant"} iconUrl={"../../assets/svgs/ambulant.svg"} />
                                        )}
                                        {row.classification ? <AcuityNeedItem key="acuity" text={row.classification} /> : null}
                                      </TableCell>
                                    )}
                                    <TableCell className={classes.tableCell}>{getOriginLocationString(row)}</TableCell>
                                    <TableCell className={classes.tableCell}>{getDestinationLocationString(row)}</TableCell>
                                    <TableCell className={classes.priorityColumn}>
                                      <PriorityBadge priority={row.priority} />
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>{getTransferStatusString(row.status)}</TableCell>
                                    <TableCell style={{ width: 20 }} align="right" className={classes.tableCell}>
                                      <IconButton aria-label="expand row" size="small">
                                        {/* <ArrowForwardIosIcon style={{ fontSize: 20 }} /> */}
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                  <Separator />
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <TableRow>
                              <TableCell align="center" colSpan={8}>
                                No Records Found
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        {roles.isVehicleAllocated &&
          _.isEmpty(activeTripId) &&
          checks.length > 0 &&
          checks.map((item: boolean) => (item ? 1 : 0)).reduce((l: any, r: any) => l + r) > 0 && (
            <StartTripFooter
              startTripClick={startTripCall}
              onClearPress={() => clearSelections()}
              transferCount={checks.map((item: boolean) => (item ? 1 : 0)).reduce((l: any, r: any) => l + r)}
            />
          )}
        {activeTripId !== "" && <ResumeTripPanel activeTripId={activeTripId} />}
      </Paper>
    </>
  );
}

export default React.memo(TransferScheduleWidget);
